// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

import { USER_DETAIL_FIELDS } from 'constants/user';

// Action Types
export const typePrefix = 'vra/user/';
export const actions = {
  SET_USER_CONFIG_FLAGS: `${typePrefix}SET_USER_CONFIG_FLAGS`,
  SET_USER_UNITS_OF_MEASURE_TEMPLATE: `${typePrefix}SET_USER_UNITS_OF_MEASURE_TEMPLATE`,
  SET_USER_DETAILS: `${typePrefix}SET_USER_DETAILS`,
  SET_ACCOUNT_COUNTRY: `${typePrefix}SET_ACCOUNT_COUNTRY`,
  SET_PRODUCT_VALIDATION_VALUES: `${typePrefix}SET_PRODUCT_VALIDATION_VALUES`,
  SET_SUPPORT_INFO: `${typePrefix}SET_SUPPORT_INFO`
};

// Reducer

export default function reducer (
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_USER_CONFIG_FLAGS:
      return {...state, flags: action.payload.flags};
    case actions.SET_USER_UNITS_OF_MEASURE_TEMPLATE:
      return {...state, unitsOfMeasureTemplate: action.payload.template};
    case actions.SET_ACCOUNT_COUNTRY:
      return {...state, accountCountry: action.payload.country};
    case actions.SET_USER_DETAILS:
      return {...state, ...action.payload};
    case actions.SET_PRODUCT_VALIDATION_VALUES:
      return {...state, productValidationValues: {...action.payload} };
    case actions.SET_SUPPORT_INFO:
      return {...state, supportInfo: { ...action.payload } };
    default:
      return state;
  }
}

// Action Creators

export const setUserConfigFlags = (flags) => {
  return {
    type: actions.SET_USER_CONFIG_FLAGS,
    payload: { flags }
  };
};

export const setUserDetails = ( userDetails ) => {
  // build object with all related fields (even if values are undefined)
  const details = Object.values(USER_DETAIL_FIELDS).reduce( ( all, field ) => {
    all[field] = userDetails[field];
    return all;
  }, {});

  return {
    type: actions.SET_USER_DETAILS,
    payload: details
  };
};

export const setProductValidationValues = (productValidationValues) => {
  return {
    type: actions.SET_PRODUCT_VALIDATION_VALUES,
    payload: productValidationValues
  };
};

export const setSupportInfo = ( supportInfo ) => {
  return {
    type: actions.SET_SUPPORT_INFO,
    payload: supportInfo
  };
};
